/**
 * 헤더 높이. **Tailwind 는 동적 클래스 조합을 스캔하지 못하므로** 값이 아니라
 * 클래스 문자열을 내보낸다.
 *
 * 헤더 아래에 붙는 것들(본문 상단 여백, sticky 사이드바의 top·max-height)이 전부
 * 이 높이에 묶여 있다. 한 곳에서 꺼내 쓰지 않으면 헤더만 바꿨을 때 사이드바가
 * 헤더 뒤로 숨거나 화면 밖으로 밀린다.
 */
export const APP_HEADER = {
  /** 헤더 바 자체의 높이 */
  height: 'h-16',
  /** 헤더가 fixed 일 때 본문이 밀려야 하는 만큼 */
  bodyOffset: 'pt-16',
  /** 투명 헤더 뒤까지 배경을 깔 섹션이 `bodyOffset` 을 되돌리는 값. 크기는 같아야 한다. */
  overlayPull: '-mt-16',
  /** 헤더 바로 아래에 붙는 sticky 요소의 top */
  stickyTop: 'top-16',
  /** 헤더를 뺀 뷰포트 높이 상한 (내용만큼만 자라는 스크롤 컨테이너용) */
  viewportRest: 'max-h-[calc(100vh-4rem)]',
  /**
   * 헤더를 뺀 뷰포트 높이 **고정**.
   *
   * `viewportRest` 는 내용 높이를 따라가므로, 안에서 접었다 폈다 하는 사이드바에
   * 쓰면 그리드 행 높이 → 문서 높이가 같이 변한다. 본문이 짧은 화면에서는
   * 사이드바가 더 큰 열이 되는데, 이때 마디를 접으면 문서가 줄어들면서 브라우저가
   * `scrollTop` 을 클램프해 **페이지가 위로 튄다.** 높이를 고정하면 안쪽 스크롤만
   * 움직이고 문서 높이는 그대로다.
   */
  viewportFill: 'h-[calc(100vh-4rem)]',
  /**
   * 헤더 바 좌우 여백. **셸 본문도 같은 값을 써야** 로고와 사이드바 첫 글자가
   * 같은 세로선에서 시작한다. 숫자(14px)는 아래 셸 상수의 좌측 존 폭 계산에도
   * 쓰이므로 여기서 바꾸면 그쪽도 같이 본다.
   */
  gutter: 'px-3.5',
  /** 위 `gutter` 의 px 값. 좌측 존 폭 = 사이드바 폭 − 이 값. */
  gutterPx: 14,
} as const;
